import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import 'moment/locale/id';
import { SuratJalanBateraiRestService } from '../surat-jalan-baterai-rest.service';
import Swal from 'sweetalert2';
import { APP_CONST } from '../../../app.const';
import { SuratJalanBateraiListComponent } from '../list/surat-jalan-baterai-list.component';
import { AuthenticationService } from '../../../libraries/libraries.module';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-add-modal',
  templateUrl: 'add-modal.component.html',
  styleUrls: ['../surat-jalan-baterai-module.scss']
})
export class AddModalComponent {
  @ViewChild('sgbSearchInput') sgbSearchInput: ElementRef;

  @Input() noTicket: string;
  @Input() noSjb: string;
  @Input() finalLocation: string;
  @Input() finalAddress: string;
  @Input() customer: {
    ktp: string;
    phoneNumber: string;
    name: string;
    motorcycleNumber: string;
    chassisNumber: string;
    batteryCode: string[];
    oldBatteryCode: string;
    newBatteryCode: string;
  };
  @Input() isRequestOpenDoor: boolean = false;

  // Props untuk existing ticket
  @Input() isExisting: boolean = false;

  isModalOpen: boolean = false;
  customerData: any = null; // To store fetched customer data
  selectedCustomer: any = null;
  uploadEndpoint = APP_CONST.API_FILE;
  @Input() ticketType: string = 'baterai_rusak';
  inputBatteryCodeType: string = 'manual';
  dealerAddress: any = [];
  isDealerAddressLoading: boolean = false;
  sjbType: any = [];
  isSjbTypeLoading: boolean = false;
  isCustomerDataLoading: boolean = false;
  today: string = new Date().toISOString().split('T')[0];
  formStep: number = 1;
  dealer: any;
  selectedLocation: any;
  motorcycleList: any;
  isLoading: boolean = false;

  shippingInfo: string = '';
  newBatteryCode: string = '';
  batteryCodes: string[] = [];
  customerBatteryCodes: string[] = [];
  isDealerWhitelistLoading: boolean = false;
  isDealerWhitelist: boolean = false;
  selectedSgb: { id: number; name: string } = { id: 0, name: '' };
  sgbList: { id: number; name: string }[] = [];
  sgbLoading: boolean = false;
  searchSgb: string = '';
  searchDebounceTimeout: any;
  showSgbDropdown: boolean = false;

  get filteredSuratJalanTypes(): { name: string; value: string }[] {
    if (this.ticketType === 'baterai_rusak' && this.isDealership()) {
      return this.sjbType.filter(t => t.value === 'return' || t.value === 'permintaan_buka_pintu');
    } else if (this.isExisting) {
      if (this.ticketType === 'baterai_rusak' && !this.isDealership()) {
        return this.sjbType.filter(t => t.value === 'pengiriman');
      }
      if (this.ticketType === 'baterai_rusak') {
        return this.sjbType.filter(t => t.value === 'return' || t.value === 'pengiriman');
      }
      return this.sjbType.filter(t => t.value === 'pengiriman');
    } else if (this.ticketType === 'request_baru') {
      return this.sjbType.filter(t => t.value === 'pengiriman' || t.value === 'permintaan');
    } else {
      return this.sjbType.filter(
        t => t.value === 'return' || t.value === 'pengiriman'
      );
    }
  }

  setDefaultSuratJalanType() {
    const options = this.filteredSuratJalanTypes;
    if (options.length > 0) {
      if (!this.formDataRequestBaru.suratJalanType) {
        this.formDataRequestBaru.suratJalanType = options[1].value;
        if (this.isExisting) {
          this.formDataRequestBaru.suratJalanType = options[0].value;
        }
      }
      if (!this.formDataBateraiRusak.suratJalanType) {
        this.formDataBateraiRusak.suratJalanType = options[0].value;
      }
    }
  }

  isDealership(): boolean {
    return this._authentication?.user?.role?.name?.toLowerCase?.() === 'dealership';
  }

  get showRequestType(): boolean {
    if (this.isExisting) {
      return false;
    }

    if (this.isDealership()) {
      return false;
    }

    return true;
  }

  addBatteryCode(): void {
    const trimmed = this.newBatteryCode.trim();
    if (trimmed && !this.batteryCodes.includes(trimmed)) {
      this.batteryCodes.push(trimmed);
      this.newBatteryCode = '';
    }
  }

  removeBatteryCode(index: number): void {
    this.batteryCodes.splice(index, 1);
  }

  prevStep() {
    this.formStep--;
  }

  nextStep() {
    if (!this.customFormValidation()) {
      return;
    }

    if (
      this.formStep === 1 &&
      this.ticketType === 'baterai_rusak' &&
      this.formDataBateraiRusak.suratJalanType === 'permintaan_buka_pintu' &&
      this.formDataBateraiRusak.customers.length === 0
    ) {
      this.addCustomer();
    }

    this.formStep++;
  }

  onBatteryCodeChange(selectedValues: any[]) {
    console.log('Selected battery codes:', selectedValues);
  }

  formDataBateraiRusak = {
    noTicket: '',
    noSuratJalan: '',
    ticketType: '',
    suratJalanType: '',
    startingLocation: '',
    startingAddress: '',
    finalLocation: '',
    finalAddress: '',
    dealerPhoneNumber: '',
    description: '',
    customer: {
      ktp: '',
      phoneNumber: '',
      name: '',
      motorcycleNumber: '',
      chassisNumber: '',
      batteryCode: [''],
      oldBatteryCode: '',
      newBatteryCode: ''
    },
    shippingInformation: {
      type: '',
      shippingNumber: '',
      reimburseAmount: null,
      shippingProof: '',
      shippingProofUrl: ''
    },
    existingTicket: null,
    dealerId: '',
    customers: [
      {
        ktp: '',
        phoneNumber: '',
        name: '',
        motorcycleNumber: '',
        chassisNumber: '',
        batteryCode: ['']
      }
    ],
    sgb: {
      id: '',
      name: ''
    }
  };

  formDataRequestBaru = {
    noTicket: '',
    noSuratJalan: '',
    ticketType: '',
    suratJalanType: '',
    startingLocation: '',
    startingAddress: '',
    finalLocation: '',
    finalAddress: '',
    description: '',
    excelFile: null,
    fileKodeBateraiName: '',
    inputMode: '',
    shippingInformation: {
      type: '',
      shippingNumber: '',
      reimburseAmount: null,
      shippingProof: '',
      shippingProofUrl: ''
    },
    existingTicket: null,
    dealerId: '',
    requestTotal: null
  };

  onMotorcycleNumberChange(index: number) {
    this.selectedCustomer = this.customerData[index];
  }

  constructor(
    private _SuratJalanBateraiRest: SuratJalanBateraiRestService,
    public _suratJalanBateraiListComponent: SuratJalanBateraiListComponent,
    private _authentication: AuthenticationService
  ) {}

  resetFormData() {
    this.formDataBateraiRusak = {
      noTicket: this.noTicket,
      noSuratJalan: this.noSjb,
      ticketType: 'baterai_rusak',
      suratJalanType: '',
      startingLocation: '',
      finalLocation: '',
      startingAddress: '',
      finalAddress: '',
      description: '',
      dealerPhoneNumber: '',
      customer: {
        ktp: this.isExisting ? this.customer.ktp : '',
        phoneNumber: this.isExisting ? this.customer.phoneNumber : '',
        name: this.isExisting ? this.customer.name : '',
        motorcycleNumber: this.isExisting ? this.customer.motorcycleNumber : '',
        chassisNumber: this.isExisting ? this.customer.chassisNumber : '',
        batteryCode: this.isExisting ? this.customer.batteryCode : [''],
        oldBatteryCode: '',
        newBatteryCode: ''
      },
      shippingInformation: {
        type: '',
        shippingNumber: '',
        reimburseAmount: 0,
        shippingProof: '',
        shippingProofUrl: ''
      },
      existingTicket: this.isExisting,
      dealerId: '',
      customers: [],
      sgb: {
        id: '',
        name: ''
      }
    };

    this.formDataRequestBaru = {
      noTicket: this.noTicket,
      noSuratJalan: this.noSjb,
      ticketType: 'request_baru',
      suratJalanType: 'pengiriman',
      startingLocation: '',
      startingAddress: '',
      finalLocation: this.isExisting ? this.finalLocation : '',
      finalAddress: this.isExisting ? this.finalAddress : '',
      description: '',
      inputMode: this.inputBatteryCodeType,
      excelFile: null,
      fileKodeBateraiName: '',
      shippingInformation: {
        type: '',
        shippingNumber: '',
        reimburseAmount: null,
        shippingProof: '',
        shippingProofUrl: ''
      },
      existingTicket: this.isExisting,
      dealerId: '',
      requestTotal: null
    };

    if (this.isExisting) {
      this.formDataBateraiRusak.finalLocation = this.finalLocation;
      this.formDataBateraiRusak.finalAddress = this.finalAddress;
      this.formDataRequestBaru.finalLocation = this.finalLocation;
      this.formDataRequestBaru.finalAddress = this.finalAddress;
    }

    if (this.isExisting && this.isRequestOpenDoor && this.formDataBateraiRusak.suratJalanType === 'return') {
      this.formDataBateraiRusak.startingLocation = this.finalLocation;
      this.formDataBateraiRusak.startingAddress = this.finalAddress;
    }

    this.batteryCodes = [];
  }

  openModal() {
    this.isModalOpen = true;
    this.customerData = null; // Reset customer data when modal is opened
    this.formStep = 1;
    this.getDealerAddress();
    this.getDealerUser();
    this.getSjbType();
    this.resetFormData();
    this.isDealership();
    this.getStatusDealerWhitelist(); // Check if dealer is whitelisted
    this.getStbList(); // Initialize SGB list
    
    // if (!this.isDealership() && !this.isExisting) {
    //   this.ticketType = 'request_baru'
    // }
  }

  closeModal() {
    this.isModalOpen = false;
    this.resetFormData();

    // Clear any pending search timeout
    if (this.searchDebounceTimeout) {
      clearTimeout(this.searchDebounceTimeout);
      this.searchDebounceTimeout = null;
    }

    // Reset SGB related properties
    this.searchSgb = '';
    this.showSgbDropdown = false;
    this.sgbList = [];
  }
  previewBatteryCode: string[] = [];

  onFileChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      const file = target.files[0];

      // ✅ Validasi ekstensi file
      const allowedExtensions = ['.xls', '.xlsx'];
      const isValidExtension = allowedExtensions.some(ext => file.name.endsWith(ext));

      if (!isValidExtension) {
        alert('File harus bertipe .xls atau .xlsx');
        return;
      }

      // ✅ Simpan file dan nama
      this.formDataRequestBaru.excelFile = file;
      this.formDataRequestBaru.fileKodeBateraiName = file.name;

      // ✅ Parse Excel
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const parsed = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          defval: ''
        }) as any[][];

        const batteryCodeList: string[] = parsed
          .slice(1) // Ambil semua baris setelah header
          .map(row => row[0]) // Ambil kolom pertama
          .filter(Boolean); // Buang yang kosong/null

        this.previewBatteryCode = batteryCodeList;
      };

      reader.readAsArrayBuffer(file);
    }
  }

  onImageFinishUploaded(image: any, inputName: string) {
    if (image?.storageFileName) {
      const value = image.storageFileName;
      const targetObj = this.ticketType === 'baterai_rusak' ? this.formDataBateraiRusak : this.formDataRequestBaru;

      const pathParts = inputName.split('.');
      let current = targetObj;

      for (let i = 0; i < pathParts.length - 1; i++) {
        const part = pathParts[i];
        if (!current[part]) current[part] = {}; // make sure the path exists
        current = current[part];
      }

      current[pathParts[pathParts.length - 1]] = value;
    } else {
      Swal.fire('Error', 'Terjadi kesalahan saat mengunggah file. Silakan coba lagi.', 'error');
    }
  }

  getDealerAddress() {
    this.isDealerAddressLoading = true;

    this._SuratJalanBateraiRest.getDealerAddress().subscribe({
      next: (response: any) => {
        this.dealerAddress = response.data;
        this.isDealerAddressLoading = false;
      },
      error: err => {
        this.isDealerAddressLoading = false;
      }
    });
  }

  getCustomerData(ktp: string, customerIndex?: number) {
    this.isCustomerDataLoading = true;

    this._SuratJalanBateraiRest.getCustomerData(ktp).subscribe({
      next: (response: any) => {
        this.customerData = response.data;

        // Handle permintaan_buka_pintu case (multiple customers)
        if (this.formDataBateraiRusak.suratJalanType === 'permintaan_buka_pintu' && typeof customerIndex === 'number') {
          // Update the specific customer in the customers array
          const customer = this.formDataBateraiRusak.customers[customerIndex];
          if (customer) {
            customer.ktp = response.data.id_card;
            customer.phoneNumber = response.data.phone_number;
            customer.name = response.data.name;

            // Set motorcycle list for dropdown
            this.motorcycleList = response.data.motorcycle;

            if (this.motorcycleList.length > 0) {
              const selectedMotor = this.motorcycleList[0];
              customer.motorcycleNumber = selectedMotor.motorcycle_number;
              customer.chassisNumber = selectedMotor.chassis_number;
              customer.batteryCode = selectedMotor.batteries?.map(b => b.battery_code) || [''];
              this.customerBatteryCodes =
                selectedMotor.batteries?.map(b => ({
                  label: b.battery_code,
                  value: b.battery_code
                })) || [];
            }
          }
        } else {
          // Handle single customer case (return or pengiriman)
          this.formDataBateraiRusak.customer.ktp = response.data.id_card;
          this.formDataBateraiRusak.customer.phoneNumber = response.data.phone_number;
          this.formDataBateraiRusak.customer.name = response.data.name;

          // Set motorcycle list for dropdown
          this.motorcycleList = response.data.motorcycle;

          if (this.motorcycleList.length > 0) {
            const selectedMotor = this.motorcycleList[0];
            this.formDataBateraiRusak.customer.motorcycleNumber = selectedMotor.motorcycle_number;
            this.formDataBateraiRusak.customer.chassisNumber = selectedMotor.chassis_number;
            this.formDataBateraiRusak.customer.batteryCode = selectedMotor.batteries?.map(b => b.battery_code) || [''];
            this.customerBatteryCodes =
              selectedMotor.batteries?.map(b => ({
                label: b.battery_code,
                value: b.battery_code
              })) || [];
          }
        }

        this.isCustomerDataLoading = false;
        Swal.fire('Success', 'Data customer ditemukan', 'success');
      },
      error: err => {
        this.isCustomerDataLoading = false;
        Swal.fire('Error', 'No. KTP customer tidak ditemukan', 'error');
      }
    });
  }

  onMotorcycleChange(customerIndex?: number) {
    // Handle permintaan_buka_pintu case (multiple customers)
    if (this.formDataBateraiRusak.suratJalanType === 'permintaan_buka_pintu' && typeof customerIndex === 'number') {
      const customer = this.formDataBateraiRusak.customers[customerIndex];
      if (!customer) return;

      const selected = this.motorcycleList.find(m => m.motorcycle_number === customer.motorcycleNumber);

      if (selected) {
        customer.chassisNumber = selected.chassis_number;
        customer.batteryCode = selected.batteries?.map(b => b.battery_code) || [''];
        this.customerBatteryCodes =
          selected.batteries?.map(b => ({
            label: b.battery_code,
            value: b.battery_code
          })) || [];
      } else {
        customer.chassisNumber = '';
        customer.batteryCode = [''];
        this.customerBatteryCodes = [];
      }
    } else {
      // Handle single customer case (return or pengiriman)
      const selected = this.motorcycleList.find(
        m => m.motorcycle_number === this.formDataBateraiRusak.customer.motorcycleNumber
      );

      if (selected) {
        this.formDataBateraiRusak.customer.chassisNumber = selected.chassis_number;
        this.formDataBateraiRusak.customer.batteryCode = selected.batteries?.map(b => b.battery_code) || [''];
        this.customerBatteryCodes =
          selected.batteries?.map(b => ({
            label: b.battery_code,
            value: b.battery_code
          })) || [];
      } else {
        this.formDataBateraiRusak.customer.chassisNumber = '';
        this.formDataBateraiRusak.customer.batteryCode = [''];
        this.customerBatteryCodes = [];
      }
    }
  }

  getDealerUser() {
    this.isDealerAddressLoading = true;

    this._SuratJalanBateraiRest.getDealerUser().subscribe({
      next: (response: any) => {
        this.dealer = response.dealer;
        if (this.dealer) {
          console.log('Dealer data:', this.dealer);
          this.formDataBateraiRusak.startingLocation = this.dealer.name;
          this.formDataBateraiRusak.startingAddress = this.dealer.address;
          this.ticketType = 'baterai_rusak';
          this.formDataBateraiRusak.dealerPhoneNumber = this.dealer.phone;
        }
        this.isDealerAddressLoading = false;
      },
      error: err => {
        this.isDealerAddressLoading = false;
      }
    });
  }

  getSjbType() {
    this.isSjbTypeLoading = true;

    this._SuratJalanBateraiRest.getSjbType().subscribe({
      next: (response: any) => {
        this.sjbType = response;
        this.isSjbTypeLoading = false;
        this.setDefaultSuratJalanType();
      },
      error: err => {
        this.isSjbTypeLoading = false;
      }
    });
  }

  getStbList(name?: string) {
    this.sgbLoading = true;

    if (name && name.trim().length < 3) {
      this.sgbLoading = false;
      return;
    }

    this._SuratJalanBateraiRest.getStbList(name).subscribe({
      next: (response: any) => {
        const data = response?.data || [];
        this.sgbList = data;
        this.sgbLoading = false;

        // Focus the input after API call completes
        setTimeout(() => {
          if (this.sgbSearchInput && this.sgbSearchInput.nativeElement) {
            this.sgbSearchInput.nativeElement.focus();
          }
        }, 100);
      },
      error: err => {
        this.sgbLoading = false;

        // Focus the input even on error
        setTimeout(() => {
          if (this.sgbSearchInput && this.sgbSearchInput.nativeElement) {
            this.sgbSearchInput.nativeElement.focus();
          }
        }, 100);
      }
    });
  }

  filterSgbList() {
    // Clear existing timeout
    if (this.searchDebounceTimeout) {
      clearTimeout(this.searchDebounceTimeout);
    }

    // Set new timeout for 1 second
    this.searchDebounceTimeout = setTimeout(() => {
      this.getStbList(this.searchSgb);
      this.showSgbDropdown = true;
    }, 500);
  }

  selectSgb(item: { id: number; name: string }) {
    this.formDataBateraiRusak.sgb = {
      id: item.id.toString(),
      name: item.name
    };
    this.searchSgb = item.name;
    this.showSgbDropdown = false;
    this.selectedSgb = item;
  }

  hideSgbDropdown() {
    // Add a small delay to allow click events to process
    setTimeout(() => {
      this.showSgbDropdown = false;
    }, 200);
  }

  getStatusDealerWhitelist() {
    this.isDealerWhitelistLoading = true;

    this._SuratJalanBateraiRest.isDealerWhitelist().subscribe({
      next: (response: any) => {
        this.isDealerWhitelist = response.isDealerWhitelist;
        this.formDataBateraiRusak.shippingInformation.type = this.isDealerWhitelist ? 'self_delivery' : '';
        this.isDealerWhitelistLoading = false;
      },
      error: err => {
        this.isDealerWhitelistLoading = false;
      }
    });
  }

  convertToFormData(data: any): FormData {
    const formData = new FormData();

    for (const key in data) {
      if (!data.hasOwnProperty(key)) continue;
      const value = data[key];

      if (value instanceof File) {
        formData.append(key, value);
      } else if (Array.isArray(value)) {
        value.forEach(item => {
          formData.append(`${key}[]`, item);
        });
      } else if (typeof value === 'object' && value !== null) {
        // Instead of flattening, stringify object
        formData.append(key, JSON.stringify(value));
      } else if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    }

    return formData;
  }

  onLocationChange(type: string, locationType: string) {
    const isRequestBaru = type === 'request_baru';
    const formData = isRequestBaru ? this.formDataRequestBaru : this.formDataBateraiRusak;

    const locationName = locationType === 'starting' ? formData.startingLocation : formData.finalLocation;

    this.selectedLocation = this.dealerAddress.find(item => item.name === locationName);

    if (!this.selectedLocation) return;

    if (locationType === 'starting') {
      formData.startingAddress = this.selectedLocation.address;
    } else if (locationType === 'final') {
      formData.finalAddress = this.selectedLocation.address;
      formData.dealerId = this.selectedLocation._id;
    }
  }

  onSgbChange() {
    const sgbId = this.formDataBateraiRusak.sgb.id;
    const sgbName = this.sgbList.find(item => item.id === Number(sgbId))?.name;

    // Find the selected SGB from the list
    this.selectedSgb = this.sgbList.find(item => item.id === Number(sgbId) && item.name === sgbName);

    if (!this.selectedSgb) return;

    // Update the form data with the selected SGB information
    this.formDataBateraiRusak.sgb = {
      id: this.selectedSgb.id.toString(),
      name: this.selectedSgb.name
    };
  }

  onSuratJalanTypeChange() {
    if (this.formDataBateraiRusak.suratJalanType === 'permintaan_buka_pintu') {
      this.formDataBateraiRusak.finalLocation = 'Customer Service';
      this.formDataBateraiRusak.finalAddress = 'Customer Service Volta Indonesia';
    }
  }

  addCustomer() {
    // Add a new customer object to the customers array
    this.formDataBateraiRusak.customers.push({
      ktp: '',
      phoneNumber: '',
      name: '',
      motorcycleNumber: '',
      chassisNumber: '',
      batteryCode: ['']
    });
  }

  removeCustomer(index: number) {
    // Remove the customer at the specified index
    this.formDataBateraiRusak.customers.splice(index, 1);
  }

  saveDraft() {
    this.isLoading = true;
    // Prepare the data to be submitted

     const rawData =
        this.ticketType === 'baterai_rusak'
          ? {
              ...this.formDataBateraiRusak,
              createdAt: this.today,
              customers: JSON.stringify(this.formDataBateraiRusak.customers)
            }
          : { ...this.formDataRequestBaru, batteries: this.batteryCodes, inputMode: this.inputBatteryCodeType };

    const formData = this.convertToFormData(rawData);

    this._SuratJalanBateraiRest.saveDraft(formData).subscribe({
      next: response => {
        Swal.fire('Success', 'Tiket berhasil dibuat!', 'success');
        this.isLoading = false;
        this._suratJalanBateraiListComponent.callHookDirectly('init');
        this.closeModal(); // Close modal on success
      },
      error: err => {
        const errorMessage = err.response.data.message;
        this.isLoading = false;
        Swal.fire('Error', `Failed to create ticket: ${errorMessage}`, 'error');
      }
    });
  }

  fieldLabels: Record<string, string> = {
    noTicket: 'No Tiket',
    noSuratJalan: 'No Surat Jalan',
    ticketType: 'Tipe Tiket',
    suratJalanType: 'Jenis Surat Jalan',
    startingLocation: 'Lokasi Awal',
    startingAddress: 'Alamat Awal',
    finalLocation: 'Lokasi Tujuan',
    finalAddress: 'Alamat Tujuan',
    description: 'Keterangan',
    shippingInformation: 'Informasi Pengiriman',
    excelFile: 'File Excel',
    fileKodeBateraiName: 'Nama File Kode Baterai',
    inputMode: 'Mode Input',
    existingTicket: 'Tiket Terkait',
    ktp: 'KTP',
    phoneNumber: 'Nomor Telepon',
    name: 'Nama',
    motorcycleNumber: 'Nomor Polisi',
    chassisNumber: 'Nomor Rangka',
    batteryCode: 'Kode Baterai',
    oldBatteryCode: 'Kode Baterai Rusak',
    newBatteryCode: 'Kode Baterai Pengganti',
    shippingProof: 'Bukti Pengiriman',
    shippingNumber: 'Nomor Resi',
    requestTotal: 'Total Permintaan'
  };

  customFormValidation() {
    if (this.ticketType === 'baterai_rusak') {
      if (this.formStep === 2 && this.formDataBateraiRusak.suratJalanType === 'return') {
        if (
          !this.formDataBateraiRusak.customer.batteryCode ||
          this.formDataBateraiRusak.customer.batteryCode.length === 0 ||
          this.formDataBateraiRusak.customer.batteryCode.every(code => !code)
        ) {
          Swal.fire('Error', 'Nomor KTP dan Kode Baterai tidak boleh kosong.', 'error');
          return false;
        }
      }

      // Validation for required fields in formDataBateraiRusak
      if (this.formStep === 1 && this.ticketType === 'baterai_rusak') {
        const requiredFields = [
          { field: 'startingLocation', label: 'Lokasi Awal', value: this.formDataBateraiRusak.startingLocation },
          { field: 'startingAddress', label: 'Alamat Awal', value: this.formDataBateraiRusak.startingAddress },
          { field: 'finalLocation', label: 'Lokasi Tujuan', value: this.formDataBateraiRusak.finalLocation },
          { field: 'finalAddress', label: 'Alamat Tujuan', value: this.formDataBateraiRusak.finalAddress },
          { field: 'suratJalanType', label: 'Jenis Surat Jalan', value: this.formDataBateraiRusak.suratJalanType }
        ];

        const emptyFields = requiredFields.filter(item => !item.value || item.value.trim() === '');

        if (emptyFields.length > 0) {
          const fieldLabels = emptyFields.map(item => item.label).join(', ');
          Swal.fire('Error', `Field berikut wajib diisi: ${fieldLabels}`, 'error');
          return false;
        }
      }

      if (
        this.formStep === 1 &&
        this.ticketType === 'baterai_rusak' &&
        (this.formDataBateraiRusak.suratJalanType === 'pengiriman' ||
          this.formDataBateraiRusak.suratJalanType === 'return')
      ) {
        if (this.formDataBateraiRusak.shippingInformation.type === '') {
          Swal.fire('Error', 'Tipe Pengiriman wajib diisi.', 'error');
          return false;
        }
      }

      if (
        this.formStep === 1 &&
        this.formDataBateraiRusak.suratJalanType === 'return' &&
        this.formDataBateraiRusak.shippingInformation.type === 'self_delivery'
      ) {
        if (
          !this.formDataBateraiRusak.shippingInformation.shippingNumber ||
          !this.formDataBateraiRusak.shippingInformation.shippingProof
        ) {
          Swal.fire('Error', 'Nomor resi dan bukti pengiriman wajib diisi.', 'error');
          return false;
        }
      }

      if (
        this.formStep === 1 &&
        this.formDataBateraiRusak.suratJalanType === 'pengiriman' &&
        this.formDataBateraiRusak.shippingInformation.type === 'external_courier'
      ) {
        if (
          !this.formDataBateraiRusak.shippingInformation.shippingNumber ||
          !this.formDataBateraiRusak.shippingInformation.shippingProof
        ) {
          Swal.fire('Error', 'Nomor resi dan bukti pengiriman wajib diisi.', 'error');
          return false;
        }
      }

      if (this.formDataBateraiRusak.suratJalanType === 'permintaan_buka_pintu') {
        if (this.formStep === 1) {
          if (this.formDataBateraiRusak.sgb.id === '' || this.formDataBateraiRusak.sgb.name === '') {
            console.log(this.formDataBateraiRusak.sgb);
            Swal.fire('Error', 'SGB wajib dipilih.', 'error');
            return false;
          }

          if (!this.formDataBateraiRusak.dealerPhoneNumber) {
            Swal.fire('Error', 'Nomor telepon dealer wajib diisi.', 'error');
            return false;
          }
        }

        if (this.formStep === 2) {
          if (
            !this.formDataBateraiRusak.customers ||
            this.formDataBateraiRusak.customers.length === 0 ||
            this.formDataBateraiRusak.customers.some(
              customer =>
                !customer.ktp ||
                !customer.phoneNumber ||
                !customer.name ||
                !customer.motorcycleNumber ||
                !customer.chassisNumber ||
                !customer.batteryCode ||
                customer.batteryCode.length === 0 ||
                customer.batteryCode.every(code => !code)
            )
          ) {
            Swal.fire('Error', 'Semua data customer wajib diisi.', 'error');
            return false;
          }
        }
      }

      return true;
    } else {
      if (this.formStep === 1) {
        const requiredFields = [
          { field: 'startingLocation', label: 'Lokasi Awal', value: this.formDataRequestBaru.startingLocation },
          { field: 'startingAddress', label: 'Alamat Awal', value: this.formDataRequestBaru.startingAddress },
          { field: 'finalLocation', label: 'Lokasi Tujuan', value: this.formDataRequestBaru.finalLocation },
          { field: 'finalAddress', label: 'Alamat Tujuan', value: this.formDataRequestBaru.finalAddress },
          { field: 'suratJalanType', label: 'Jenis Surat Jalan', value: this.formDataRequestBaru.suratJalanType }
        ];

        const emptyFields = requiredFields.filter(item => !item.value || item.value.trim() === '');

        if (emptyFields.length > 0) {
          const fieldLabels = emptyFields.map(item => item.label).join(', ');
          Swal.fire('Error', `Field berikut wajib diisi: ${fieldLabels}`, 'error');
          return false;
        }
      }

      if (this.formDataRequestBaru.suratJalanType === 'pengiriman') {
        if (
          this.inputBatteryCodeType === 'manual' &&
          (!this.batteryCodes || this.batteryCodes.length === 0 || this.batteryCodes.every(code => !code))
        ) {
          Swal.fire('Error', 'Kode Baterai tidak boleh kosong.', 'error');
          return false;
        }

        if (this.inputBatteryCodeType === 'excel' && !this.formDataRequestBaru.excelFile) {
          Swal.fire('Error', 'File Excel Kode Baterai harus diunggah.', 'error');
          return false;
        }

        if (!this.formDataRequestBaru.shippingInformation.type) {
          Swal.fire('Error', 'Tipe Pengiriman wajib diisi.', 'error');
          return false;
        }

        if (this.formDataRequestBaru.shippingInformation.type === 'external_courier') {
          if (!this.formDataRequestBaru.shippingInformation.shippingNumber) {
            Swal.fire('Error', 'Nomor resi wajib diisi.', 'error');
            return false;
          }

          if (!this.formDataRequestBaru.shippingInformation.shippingProof) {
            Swal.fire('Error', 'Bukti pengiriman wajib diisi.', 'error');
            return false;
          }
        }
      }

      if (this.formDataRequestBaru.suratJalanType === 'permintaan') {
        if (!this.formDataRequestBaru.requestTotal || this.formDataRequestBaru.requestTotal <= 0) {
          Swal.fire('Error', 'Total permintaan harus diisi.', 'error');
          return false;
        }

        if (!this.formDataRequestBaru.description || this.formDataRequestBaru.description.trim() === '') {
          Swal.fire('Error', 'Keterangan permintaan harus diisi.', 'error');
          return false;
        }
      }

      return true;
    }
  }

  // Method to handle the submit action
  onSubmit(form) {
    this.isLoading = true;

    if (!this.customFormValidation()) {
      this.isLoading = false;
      return;
    }

    // if (form.valid) {
      const rawData =
        this.ticketType === 'baterai_rusak'
          ? {
              ...this.formDataBateraiRusak,
              createdAt: this.today,
              customers: JSON.stringify(this.formDataBateraiRusak.customers)
            }
          : { ...this.formDataRequestBaru, batteries: this.batteryCodes, inputMode: this.inputBatteryCodeType };

      const formData: FormData = this.convertToFormData(rawData);

      // For Debugging
      const formDataObject: Record<string, any> = {};

      formData.forEach((value, key) => {
        formDataObject[key] = value;
      });

      this._SuratJalanBateraiRest.create(formData).subscribe({
        next: response => {
          Swal.fire('Success', 'Tiket berhasil dibuat!', 'success');
          this.closeModal();
          this._suratJalanBateraiListComponent.callHookDirectly('init');
          this.isLoading = false;
        },
        error: err => {
          const errorMessage = err.response.data.message;
          Swal.fire('Error', `Failed to create ticket: ${errorMessage}`, 'error');
          this.isLoading = false;
        }
      });
    // } else {
    //   const invalidFields = Object.keys(form.controls).filter(key => form.controls[key].invalid);

    //   // Tandain semua field yang error
    //   invalidFields.forEach(fieldName => {
    //     const control = form.controls[fieldName];
    //     control.markAsTouched();
    //   });

    //   console.log("invalidFields", invalidFields);

    //   // Mapping ke label yang lebih manusiawi
    //   const mappedLabels = invalidFields.map(field => this.fieldLabels[field] || field);

    //   Swal.fire('Error', `Mohon lengkapi field berikut: ${mappedLabels.join(', ')}`, 'error');
    //   this.isLoading = false;
    // }
  }
}
